import { get, post } from '@/unit/request.js'
export default {
    login(data) {
        return post('admin/login', data)
    },
    getUserInfo() {
        return get('index/userInfo', {})
    }

}